import styled from '@emotion/styled';

type HideOnProps = {
  breakpoint: number;
};

export const HideOnMobile = styled.div<HideOnProps>`
  display: none;

  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: block;
  }
`;

export const HideOnDesktop = styled.div<HideOnProps>`
  @media (min-width: ${({ breakpoint }) => `${breakpoint}px`}) {
    display: none;
  }
`;
